export interface DocumentGeneratorResponse {
	status: boolean;
	key?: string;
	attachmentName?: string;
}
